module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 5);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var FETCH_SAVINGS_TRANSACTIONS_REQUEST = exports.FETCH_SAVINGS_TRANSACTIONS_REQUEST = 'FETCH_SAVINGS_TRANSACTIONS_REQUEST';
  var FETCH_SAVINGS_TRANSACTIONS_SUCCESS = exports.FETCH_SAVINGS_TRANSACTIONS_SUCCESS = 'FETCH_SAVINGS_TRANSACTIONS_SUCCESS';
  var FETCH_SAVINGS_TRANSACTIONS_FAILURE = exports.FETCH_SAVINGS_TRANSACTIONS_FAILURE = 'FETCH_SAVINGS_TRANSACTIONS_FAILURE';
  var FETCH_SAVINGS_ACCOUNT_REQUEST = exports.FETCH_SAVINGS_ACCOUNT_REQUEST = 'FETCH_SAVINGS_ACCOUNT_REQUEST';
  var FETCH_SAVINGS_ACCOUNT_SUCCESS = exports.FETCH_SAVINGS_ACCOUNT_SUCCESS = 'FETCH_SAVINGS_ACCOUNT_SUCCESS';
  var FETCH_SAVINGS_ACCOUNT_FAILURE = exports.FETCH_SAVINGS_ACCOUNT_FAILURE = 'FETCH_SAVINGS_ACCOUNT_FAILURE';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _actions = __webpack_require__(4);

  var actions = _interopRequireWildcard(_actions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, actions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$accountsDefini = state.accountsDefinition,
        accountsDefinition = _state$accountsDefini === undefined ? {} : _state$accountsDefini;
    var mode = accountsDefinition.mode,
        status = accountsDefinition.status,
        accounts = accountsDefinition.accounts,
        isFetching = accountsDefinition.isFetching,
        _accountsDefinition$e = accountsDefinition.error,
        error = _accountsDefinition$e === undefined ? null : _accountsDefinition$e;
    return {
      mode: mode,
      status: status,
      accounts: accounts,
      isFetching: isFetching,
      error: error
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _types = __webpack_require__(0);

  var _immutabilityHelper = __webpack_require__(7);

  var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var accountsDefinition = function accountsDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var oldAccounts = void 0;
    var index = void 0;
    var account = void 0;

    switch (action.type) {
      case _types.FETCH_SAVINGS_TRANSACTIONS_SUCCESS:
        {
          oldAccounts = state.accounts;
          index = oldAccounts.Accounts.findIndex(function (x) {
            return x.AccountKey.Key === action.accountkey.Key;
          });
          account = oldAccounts.Accounts[index];
          var transactions = action.transactions;
          var withTransactionsRange = (0, _immutabilityHelper2.default)(transactions, {
            Range: {
              $set: action.range
            }
          });
          var accountWithTransactions = (0, _immutabilityHelper2.default)(account, {
            transactions: {
              $set: withTransactionsRange
            }
          });
          var updatedAccounts = (0, _immutabilityHelper2.default)(oldAccounts, {
            Accounts: _defineProperty({}, index, {
              $set: accountWithTransactions
            })
          });
          return _extends({}, state, {
            accounts: updatedAccounts,
            isFetching: action.isFetching
          });
        }

      case _types.FETCH_SAVINGS_ACCOUNT_SUCCESS:
        {
          oldAccounts = state.accounts;
          index = oldAccounts.Accounts.findIndex(function (x) {
            return x.AccountKey.Key === action.accountkey.Key;
          });
          account = oldAccounts.Accounts[index];
          var newAccount = action.account;
          var withOldTransactions = (0, _immutabilityHelper2.default)(newAccount, {
            transactions: {
              $set: account.transactions
            }
          });
          var updatedByAccountsFetch = (0, _immutabilityHelper2.default)(oldAccounts, {
            Accounts: _defineProperty({}, index, {
              $set: withOldTransactions
            })
          });
          return _extends({}, state, {
            accounts: updatedByAccountsFetch,
            isFetching: action.isFetching
          });
        }

      case _types.FETCH_SAVINGS_TRANSACTIONS_FAILURE:
      case _types.FETCH_SAVINGS_TRANSACTIONS_REQUEST:
      case _types.FETCH_SAVINGS_ACCOUNT_FAILURE:
      case _types.FETCH_SAVINGS_ACCOUNT_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      default:
        return state;
    }
  };

  exports.default = accountsDefinition;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fetchSavingsAccountTransactionsIfNeeded = exports.shouldFetchSavingsAccountTransactions = exports.fetchSavingsAccountTransactions = exports.receiveSavingsAccountTransactions = exports.failedSavingsAccountTransactions = exports.requestSavingsAccountTransactions = exports.fetchSavingsAccountIfNeeded = exports.shouldFetchSavingsAccount = exports.fetchSavingsAccount = exports.receiveSavingsAccount = exports.failedSavingsAccount = exports.requestSavingsAccount = undefined;

  var _interact = __webpack_require__(6);

  var _types = __webpack_require__(0);

  var requestSavingsAccount = exports.requestSavingsAccount = function requestSavingsAccount() {
    return {
      type: _types.FETCH_SAVINGS_ACCOUNT_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var failedSavingsAccount = exports.failedSavingsAccount = function failedSavingsAccount(error) {
    return {
      type: _types.FETCH_SAVINGS_ACCOUNT_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var receiveSavingsAccount = exports.receiveSavingsAccount = function receiveSavingsAccount(json, accountkey) {
    return {
      type: _types.FETCH_SAVINGS_ACCOUNT_SUCCESS,
      account: json,
      accountkey: accountkey,
      isFetching: false,
      error: null
    };
  };

  var fetchSavingsAccount = exports.fetchSavingsAccount = function fetchSavingsAccount(request) {
    return function (dispatch) {
      dispatch(requestSavingsAccount());
      return fetch(_interact.Connection.baseUrl('accounts') + 'v3.0/savings/getaccount', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(receiveSavingsAccount(json, request.AccountKey));
      }).catch(function (error) {
        return dispatch(failedSavingsAccount(error));
      });
    };
  };

  var shouldFetchSavingsAccount = exports.shouldFetchSavingsAccount = function shouldFetchSavingsAccount(state, request) {
    if (!state.accounts || !state.accounts.Accounts) {
      return false;
    }

    var index = state.accounts.Accounts.findIndex(function (x) {
      return x.AccountKey.Key === request.AccountKey.Key;
    });

    if (index == -1) {
      return false;
    }

    if (!state.accounts.Accounts[index] || !state.accounts.Accounts[index].ExpiryDate) {
      return true;
    }

    var expiry = state.accounts.Accounts[index].ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchSavingsAccountIfNeeded = exports.fetchSavingsAccountIfNeeded = function fetchSavingsAccountIfNeeded(request) {
    return function (dispatch, getState) {
      if (shouldFetchSavingsAccount(getState().accountsDefinition, request)) {
        return dispatch(fetchSavingsAccount(request));
      }
    };
  };

  var requestSavingsAccountTransactions = exports.requestSavingsAccountTransactions = function requestSavingsAccountTransactions() {
    return {
      type: _types.FETCH_SAVINGS_TRANSACTIONS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var failedSavingsAccountTransactions = exports.failedSavingsAccountTransactions = function failedSavingsAccountTransactions(error) {
    return {
      type: _types.FETCH_SAVINGS_TRANSACTIONS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var receiveSavingsAccountTransactions = exports.receiveSavingsAccountTransactions = function receiveSavingsAccountTransactions(json, accountkey, range) {
    return {
      type: _types.FETCH_SAVINGS_TRANSACTIONS_SUCCESS,
      transactions: json,
      accountkey: accountkey,
      range: range,
      isFetching: false,
      error: null
    };
  };

  var fetchSavingsAccountTransactions = exports.fetchSavingsAccountTransactions = function fetchSavingsAccountTransactions(request) {
    return function (dispatch) {
      dispatch(requestSavingsAccountTransactions());
      return fetch(_interact.Connection.baseUrl('accounts') + 'v3.0/savings/gettransactions', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(receiveSavingsAccountTransactions(json, request.AccountKey, request.Range));
      }).catch(function (error) {
        return dispatch(failedSavingsAccountTransactions(error));
      });
    };
  };

  var shouldFetchSavingsAccountTransactions = exports.shouldFetchSavingsAccountTransactions = function shouldFetchSavingsAccountTransactions(state, request) {
    if (!state.accounts || !state.accounts.Accounts) {
      return false;
    }

    var index = state.accounts.Accounts.findIndex(function (x) {
      return x.AccountKey.Key === request.AccountKey.Key;
    });

    if (index == -1) {
      return false;
    }

    if (!state.accounts.Accounts[index].transactions || !state.accounts.Accounts[index].transactions.ExpiryDate) {
      return true;
    }

    if (state.accounts.Accounts[index].transactions && state.accounts.Accounts[index].transactions.Range) {
      if (!request.Range && state.accounts.Accounts[index].transactions.Range) {
        return true;
      }

      if (request.Range && !state.accounts.Accounts[index].transactions.Range) {
        return true;
      }

      if (state.accounts.Accounts[index].transactions.Range.To != request.Range.To || state.accounts.Accounts[index].transactions.Range.From != request.Range.From) {
        return true;
      }
    }

    var expiry = state.accounts.Accounts[index].transactions.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchSavingsAccountTransactionsIfNeeded = exports.fetchSavingsAccountTransactionsIfNeeded = function fetchSavingsAccountTransactionsIfNeeded(request) {
    return function (dispatch, getState) {
      if (shouldFetchSavingsAccountTransactions(getState().accountsDefinition, request)) {
        return dispatch(fetchSavingsAccountTransactions(request));
      }
    };
  };
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.accountsDefinition = undefined;

  var _reducer = __webpack_require__(3);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(2);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(1);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.accountsDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("immutability-helper");
  /***/
}
/******/
]);